import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography
} from "@mui/material";
import imgMixTapan from '../../assets/images/ncp/ncp_1.png';
import ncps_prizes from '../../assets/images/ncp/ncps_prizes.png';
import promo_despre_alcool from '../../assets/images/promo-despre-alcool.png';
import useMixTapanStyles from "../../styles/ncp/mix_tapan";
import ImageComponent from "../../utils/ImageComponent";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import logo_carrefour_dark from '../../assets/images/ncp/logo_carrefour.png';
import logo_auchan_dark from '../../assets/images/ncp/logo_auchan.png';
import logo_mega_dark from '../../assets/images/ncp/logo_mega.png';
import logo_kaufland_dark from '../../assets/images/ncp/logo_kaufland.png';
import logo_profi_dark from '../../assets/images/ncp/logo_profi.png';
import logo_penny_dark from '../../assets/images/ncp/logo_penny.png';
import logo_anabella_dark from '../../assets/images/ncp/logo_anabella.png';
import logo_bertis_dark from '../../assets/images/ncp/logo_bertis.png';
import logo_merkur_dark from '../../assets/images/ncp/logo_mercur.png';
import ecran1 from '../../assets/images/ncp/2025/ecran1.png';
import { isBeforeAugust31 } from "../../utils/dateTimesUtils";
import ecran1_mobile from '../../assets/images/ncp/2025/background_mobile.png';
import desktop from '../../assets/images/ncp/2025/banner_site_castigatori.png';
import mobile from '../../assets/images/ncp/2025/mobile_castigatori.png';

const MixTapan: React.FC = () => {
    const mixTapanStyle = useMixTapanStyles();
    const [showDialog, setShowDialog] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClickOpenDialogRegulamente = () => {
        setShowDialog(true);
    };

    const handleCloseDialogRegulamente = () => {
        setShowDialog(false);
    };

    return (
        <Grid container>
            {/* <Grid item xs={12} md={6} className={mixTapanStyle.boxLeft}>
                <ImageComponent src={imgMixTapan} alt={'Mix țapăn de festival'}/>
                {isBeforeAugust31() ?
                    <Typography className={mixTapanStyle.textSecondary}>Încearcă MIX-ul Kozel și poți câștiga premii țapene
                        de festival</Typography> :
                    <Typography className={mixTapanStyle.textSecondary}>Campania s-a încheiat. <br/>Mulțumim pentru participare!<br/>
                        Fii pe fază. Vom afișa aici lista câștigătorilor.</Typography>
                }
                <Button className={mixTapanStyle.buttonRegulament}
                        onClick={handleClickOpenDialogRegulamente}>Regulament</Button>
            </Grid>
            <Grid item xs={12} md={6} className={mixTapanStyle.boxRight}>
                <Grid container>
                    <Grid item xs={12} className={mixTapanStyle.wrapperRightText}>
                        <Typography className={mixTapanStyle.textPrimary}>Cumpără Kozel Premium sau Kozel Dark în orice
                            combinație, pe un singur bon fiscal, înscrie bonul aici și poți câștiga:</Typography>
                        <ImageComponent src={ncps_prizes} alt={'Premiile'}/>
                    </Grid>
                    <Grid item xs={12} className={mixTapanStyle.promotionInterval}>
                        <Typography>Durata promotiei: <b>01.07.2024 - 31.08.2024</b></Typography>
                        <img src={promo_despre_alcool} alt={'promo despre alcool'}/>
                    </Grid>
                </Grid>
            </Grid> */}

            <Grid item xs={12} style={{ position: 'relative' }}>
                {/* Imaginea pentru desktop */}
                <img
                    src={desktop}
                    alt={'Kozel Mix Țapăn 2025'}
                    className={mixTapanStyle.fullWidthImage}
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.open('/pdf/2025/Publicare castigatori_Kozel MT.pdf', '_blank')}
                />

                {/* Imaginea pentru mobile */}
                <img
                    src={mobile}
                    alt={'Kozel Mix Țapăn 2025'}
                    className={mixTapanStyle.fullWidthImageMobile}
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.open('/pdf/2025/Publicare castigatori_Kozel MT.pdf', '_blank')}
                />

                {/* Text și imagine - overlay pentru ambele versiuni */}
                {/* <div className={mixTapanStyle.bottomOverlayMobileOnly}>
                    <Typography className={mixTapanStyle.bottomText}>
                        Durata campaniei: <b>07.08.2025 - 01.09.2025</b>
                    </Typography>
                    <a href="https://desprealcool.ro/" target="_blank" rel="noopener noreferrer">
                        <img src={promo_despre_alcool} alt={'promo despre alcool'} className={mixTapanStyle.promoImage}/>
                    </a>
                </div> */}
            </Grid>
            <Dialog
                fullScreen={fullScreen}
                open={showDialog}
                onClose={handleCloseDialogRegulamente}
                aria-labelledby="responsive-dialog-title"
                className={mixTapanStyle.dialog}
            >
                <DialogTitle id="responsive-dialog-title" className={mixTapanStyle.dialogTitle}>
                    {"Regulament"}
                </DialogTitle>
                <DialogContent className={mixTapanStyle.dialogContent}>
                    <List className={mixTapanStyle.dialogContentList}>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulamentul oficial al Campaniei Kozel “Mix Tapan de festival” - Carrefour.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_carrefour_dark" src={logo_carrefour_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Carrefour"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulamentul oficial al Campaniei Kozel “Mix Tapan de festival” - Auchan.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_auchan_dark" src={logo_auchan_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Auchan"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulamentul oficial al Campaniei Kozel “Mix Tapan de festival” - Kaufland.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_kaufland_dark" src={logo_kaufland_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Kaufland"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulamentul oficial al Campaniei Kozel “Mix Tapan de festival” - Mega Image.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_mega_dark" src={logo_mega_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Mega Image"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulamentul oficial al Campaniei Kozel “Mix Tapan de festival” - Penny.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_penny_dark" src={logo_penny_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Penny"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulamentul oficial al Campaniei Kozel “Mix Tapan de festival“ - Profi.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_profi_dark" src={logo_profi_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Profi"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulament KOZEL Mixeaza Tapan si castiga-TT-august.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_anabella_dark" src={logo_anabella_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Anabella"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulament KOZEL Mixeaza Tapan si castiga-TT-august.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_bertis_dark" src={logo_bertis_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Bertis"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component="a"
                                href="/pdf/2024/Regulament KOZEL Mixeaza Tapan si castiga-TT-august.pdf"
                                target="_blank" rel="noopener">
                                <ListItemIcon>
                                    <img alt="logo_merkur_dark" src={logo_merkur_dark} />
                                </ListItemIcon>
                                <ListItemText primary={"Merkur"} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button color={'primary'} onClick={handleCloseDialogRegulamente}
                        className={mixTapanStyle.buttonCloseModal}>Close</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default MixTapan;